import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'getToTitle',
    pure: true
})
export class ToTitlePipe implements PipeTransform {

    transform(value: string, args?: any): any {
        return this.getToTitle(value)
    }
    getToTitle(n: string): String {
        if (n != null) {
            return n[0].toUpperCase() + n.slice(1)
        } else {
            return 'Error when trying to capitalize string';
        }
    }
}